import { useRouter } from 'next/router';

import { useIsBiggerThanDesktop } from '~/domains/common/hooks/mediaQueries';
import { Routes } from '~/domains/common/constants/routes';
import { QuickPicksLeaguePageHeader } from '~/domains/contest/domains/quickPick/components/Board/BoardSearch/QuickPicksLeaguePageHeader';
import { QuickPicksBoardSearchHeader } from '~/domains/contest/domains/quickPick/components/Board/BoardSearch/QuickPicksBoardSearchHeader';
import { MarketsLeaguePageHeader } from '~/domains/market/components/MarketsLeaguePageHeader/MarketsLeaguePageHeader';
import isWebView from '~/utils/isWebView';

import ConnectedAppShellHeader from '../AppShellHeader/ConnectedAppShellHeader';

export function AppShellHeaderRoot() {
  const router = useRouter();
  const isDesktopUp = useIsBiggerThanDesktop();
  const isMarketsLeaguePath =
    router.pathname === Routes.marketsSport('[sport]', '[type]') ||
    router.pathname === Routes.marketsSportMarketGroup('[sport]', '[type]', '[marketGroupId]');

  if (isWebView()) {
    return false;
  }

  if (router.pathname === Routes.quickPicksBoardSearch({})) {
    return <QuickPicksBoardSearchHeader />;
  }

  const isLeagueBoardPathByAsPath =
    router.asPath.startsWith('/quick-picks/board/') &&
    !router.asPath.startsWith('/quick-picks/board/search');
  const isLeagueBoardPathByPathname = router.pathname === '/quick-picks/board/league';
  const isQuickPicksLeagueBoardPath = isLeagueBoardPathByAsPath || isLeagueBoardPathByPathname;

  if (isQuickPicksLeagueBoardPath && !isDesktopUp) {
    return <QuickPicksLeaguePageHeader />;
  }

  if (isMarketsLeaguePath && !isDesktopUp) {
    return <MarketsLeaguePageHeader />;
  }

  return <ConnectedAppShellHeader />;
}
